import client from "@/utils/api/client";
import {
  ProductKind,
  ProductVariationWithProductResponse,
} from "@/web-client/api";
import useSWR from "swr";
import { ProductSearchQueryParameter } from "@/types/ProductSearchQueryParameter";

type UseLatestProductVariationsReturn = {
  productVariations: ProductVariationWithProductResponse[];
  mutate: (
    variation?: ProductVariationWithProductResponse[],
    shouldRevaidate?: boolean,
  ) => void;
};

const useLatestProductVariations = (
  key: string,
  limit: number,
  kind: ProductKind,
  params?: ProductSearchQueryParameter,
): UseLatestProductVariationsReturn => {
  const { data, mutate } = useSWR<ProductVariationWithProductResponse[]>(
    key,
    async () => {
      const { data } = await client.productVariationsSearchGet({
        kind,
        categoryId: params ? Number(params.category_id) : undefined,
        limit,
      });

      return data.results;
    },
  );

  return {
    productVariations: data || [],
    mutate,
  };
};

export default useLatestProductVariations;
